function cfg() {
    const c = window.DVMaterial;
    if (!c)
        throw new Error('Konfiguration fehlt (DVMaterial).');
    return c;
}
async function request(pfad, init) {
    const c = cfg();
    const res = await fetch(c.restUrl + pfad, {
        ...init,
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': c.nonce,
            ...(init?.headers ?? {}),
        },
    });
    const daten = await res.json().catch(() => null);
    if (!res.ok) {
        throw new Error(daten?.message || `Fehler (${res.status})`);
    }
    return daten;
}
export const api = {
    getPlan: () => request('/plan'),
    anlegen: (d) => request('/anfragen', { method: 'POST', body: JSON.stringify(d) }),
    loeschen: (id) => request(`/anfragen/${id}`, { method: 'DELETE' }),
    statusSetzen: (id, status, notiz) => request(`/anfragen/${id}/status`, {
        method: 'POST',
        body: JSON.stringify({ status, notiz }),
    }),
};
